export interface OrgChartColumnMapping {
  employeeName: string | null;
  directManager: string | null;
  position: string | null;
}

export interface OrgChartItem {
  id: string;
  self: string;
  parent?: string;
  job_title?: string;
}

export const PossibleTypesForFields = {
  "Employee name": ["text", "email", "people", "name"],
  "Direct manager": ["text", "email", "people"],
  Position: ["text"],
} as const;

export const COLUMN_MAPPING_FIELDS = {
  employeeName: {
    label: "Employee name",
    labelWithArrow: true,
    placeholder: "Choose column",
    validTypes: PossibleTypesForFields["Employee name"],
  },
  directManager: {
    label: "Direct manager",
    labelWithArrow: true,
    placeholder: "Choose column",
    validTypes: PossibleTypesForFields["Direct manager"],
  },
  position: {
    label: "Position",
    labelWithArrow: true,
    placeholder: "Choose column",
    validTypes: PossibleTypesForFields.Position,
  },
} as const;
